// Angular
import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

// Platform
import { CerFormView, CerViewType } from '@form/cer-form-view';
import { ICerFormViewType } from './cer-form-view-type.interface';
import { UiActionTypeEnum, UiCommandEvent, UiCommandSourceEnum } from '@ui/cer-ui-types';

import { CerFormViewTypeListComponent } from './cer-form-view-type-list.component';
import { CerFormViewTypeTreeComponent } from './cer-form-view-type-tree.component';
import { CerFormViewTypeCustomComponent } from './cer-form-view-type-custom.component';
import { CerFormViewTypeDocumentComponent } from './cer-form-view-type-document/cer-form-view-type-document.component';

@Component({
  selector: 'cer-form-view',
  templateUrl: './cer-form-view.component.html'
})

export class CerFormViewComponent implements OnInit, OnDestroy {
  private _view: CerFormView;
  get view(): CerFormView { return this._view; };
  @Input() set view(view: CerFormView) {
    if (view && this._view != view) {
      this._view = view;
      this.viewSubscription = this._view.commandSubscribe(e => this.onViewCommandType(e));
    }
  }

  private viewSubscription: Subscription;
  public ngOnDestroy(): void {
    this.viewSubscription?.unsubscribe();
  }

  private selectedViewType: ICerFormViewType;
  protected selectedTemplate: TemplateRef<any> | null = null;
  protected titleHeaderVisible: boolean = true;
  protected titleHeader: string = '';

  protected isList: boolean = false;
  protected isTree: boolean = false;
  protected isCustom: boolean = false;
  protected isDocument: boolean = false;

  public ngOnInit() {
    this.isList = this.view?.viewType == 'list';
    this.isTree = this.view?.viewType == 'tree';
    this.isCustom = this.view?.viewType == 'custom';
    this.isDocument = this.view?.viewType == 'document';
  }

  public ngAfterViewInit() {
    this.selectViewType(this.view?.viewType);
    this.titleHeaderUpdate(this.view.title);
  }

  @ViewChild('list') private list: CerFormViewTypeListComponent;
  @ViewChild('tree') private tree: CerFormViewTypeTreeComponent;
  @ViewChild('custom') private custom: CerFormViewTypeCustomComponent;
  @ViewChild('document') private document: CerFormViewTypeDocumentComponent;

  public select() {
    const e: UiCommandEvent = { source: UiCommandSourceEnum.DesignChange, actionType: UiActionTypeEnum.Reflow, subAction: 'none', commandId: null, args: null };
    this.onViewCommandType(e);
  }

  public onViewCommandType(e: UiCommandEvent) {
    switch (e.source) {
      case UiCommandSourceEnum.DesignChange:
        this.onViewCommandDesignChange(e);
        break;
    }
    if (this.selectedViewType != null) {
      this.selectedViewType.onCommand(e);
    }
  }

  private onViewCommandDesignChange(e: UiCommandEvent) {
    switch (e.actionType) {
      case UiActionTypeEnum.TitleUpdate:
        this.titleHeaderUpdate(e.rowData?.title);
        break;
    }
  }

  private titleHeaderUpdate(titleHeader: string) {
    this.titleHeader = titleHeader?.length > 0 ? titleHeader : '';
    this.titleHeaderVisible = (this.titleHeader.length >  0 && this.view?.titleHeaderVisible == true);
  }

  private selectViewType(viewType: CerViewType): void {
    switch (viewType) {
      case 'list':
      case 'card':
        this.selectedViewType = this.list;
        break;
      case 'tree':
        this.selectedViewType = this.tree;
        break;
      case 'custom':
        this.selectedViewType = this.custom;
        break;
      case 'document':
        this.selectedViewType = this.document;
        break;
    }
    if (this.selectedViewType != null) {
      this.selectedTemplate = this.selectedViewType.template;
    }
  }
}
